import React from "react";
import {
  Box,
  Divider,
  Heading,
  Flex,
  TableContainer,
  Table,
  Tbody,
  Tr,
  Td,
  Thead,
  Th,
} from "@chakra-ui/react";

const SettlementInvoice = ({ invoice_details }) => {
  return (
    <Box
      shadow={"md"}
      rounded={"md"}
      border={"1px"}
      borderColor={"gray.200"}
      bgColor={"#FFFFFF"}
      my={5}
      p={3}
      pb={0}
    >
      <Flex justifyContent={"space-between"}>
        <Box>
          <Heading size={"md"} mb={2}>{`Settlement Invoice`}</Heading>
        </Box>
      </Flex>
      <Divider size={1} mt={2} borderBottomColor={"rgba(0, 0, 0, 0.15)"} />

      <TableContainer>
        <Table variant="unstyled"  >
          <Thead >
            <Tr>
              <Th pl={0}></Th>
              <Th></Th>
              <Th borderBottom={'1px solid rgba(0, 0, 0, 0.15)'}>Debit</Th>
              <Th borderBottom={'1px solid rgba(0, 0, 0, 0.15)'} borderLeft={'1px solid rgba(0, 0, 0, 0.15)'}>Credit</Th>
            </Tr>
          </Thead>
          <Tbody>
            {invoice_details.map((e, i) => {
              return (    
                  <Tr key={i} overflow="hidden" whiteSpace="pre-wrap" >
                    <Td pl={1} fontWeight={'semibold'} >{e.title}</Td>
                    <Td px={4}>{e.title_value}</Td>
                    <Td>{e.debit.length > 0  ? "₹" + e.debit : null}</Td>
                    <Td pr={1} borderLeft={'1px solid rgba(0, 0, 0, 0.15)'}>{e.credit.length > 0  ? "₹" + e.credit : null}</Td>
                  </Tr>
              );
            })}
            <Tr borderTop={'1px solid rgba(0, 0, 0, 0.15)'} overflow="hidden" whiteSpace="pre-wrap">
              <Td pl={1} fontWeight={'semibold'}>Settlement Amount</Td>
              <Td px={4}></Td>
              <Td fontWeight={'bold'}>₹1,000</Td>
              <Td fontWeight={'bold'} borderLeft={'1px solid rgba(0, 0, 0, 0.15)'}>₹1,000</Td>
            </Tr>
          </Tbody>
        </Table>
      </TableContainer>
    </Box>
  );
};

export default SettlementInvoice;
